import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import PlatformHealth from "../tabs/PlatformHealth";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function PlatformHealthScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_PLATFORM_HEALTH} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_PLATFORM_HEALTH} />
        <PlatformHealth filters={filters} filterBar={renderFilterBar("platformHealth")} />
      </Container>
    </div>
  );
}
